import React, { Component } from "react";
import Predefine_3_CrewNeck_Cricket from "../components/Predefine_3_CrewNeck_Cricket/Predefine_3_CrewNeck_Cricket";

export class Predefine_3_CrewNeck_CricketPage extends Component {
  render() {
    return <Predefine_3_CrewNeck_Cricket />;
  }
}

export default Predefine_3_CrewNeck_CricketPage;
